"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AstraMechanica = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Tags_1 = require("../Tags");
const SelectCard_1 = require("../../inputs/SelectCard");
class AstraMechanica extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.ASTRA_MECHANICA,
            tags: [Tags_1.Tags.SCIENCE],
            cost: 7,
            metadata: {
                cardNumber: 'X51',
                description: 'RETURN UP TO 2 PLAYED EVENT CARDS TO YOUR HAND. THEY MAY NOT BE CARDS THAT PLACE SPECIAL TILES.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.cards(2).secondaryTag(Tags_1.Tags.EVENT).asterix();
                }),
            },
        });
    }
    play(player) {
        const events = this.getCards(player);
        if (events.length === 0) {
            player.game.log('${0} had no events', (b) => b.player(player));
            return undefined;
        }
        return new SelectCard_1.SelectCard('Select up 2 to events to return to your hand', 'Select', events, (cards) => {
            for (const card of cards) {
                player.playedCards.splice(player.playedCards.indexOf(card), 1)[0];
                player.cardsInHand.push(card);
                player.game.log('${0} returned ${1} to their hand', (b) => b.player(player).card(card));
            }
            return undefined;
        }, { max: 2, min: 0 });
    }
    getCards(player) {
        const eventCardsThatPlaceSpecialTiles = [
            CardName_1.CardName.DEIMOS_DOWN_ARES,
            CardName_1.CardName.DEIMOS_DOWN_PROMO,
            CardName_1.CardName.LAVA_FLOWS,
            CardName_1.CardName.LAVA_FLOWS_ARES,
            CardName_1.CardName.METALLIC_ASTEROID,
            CardName_1.CardName.LUNAR_MINE_URBANIZATION,
        ];
        return player.playedCards.filter((card) => {
            if (card.cardType !== CardType_1.CardType.EVENT)
                return false;
            if (eventCardsThatPlaceSpecialTiles.includes(card.name)) {
                return false;
            }
            return true;
        });
    }
}
exports.AstraMechanica = AstraMechanica;
//# sourceMappingURL=AstraMechanica.js.map